<template>
    <div style="text-align:center;padding:1em;">
        Texte : <br>
        «{{ text.content }}»
    	<hr>
        <div>
    		<audio ref="listeningTag" :src="soundUrl()" @ended="reset()" preload="auto" controls>
    		</audio>
    	</div>
    </div>
</template>

<script>
    export default {
    	methods: {
    		soundUrl()	{
    			return process.env.API_URL.replace('app_dev.php', '') + '/' + this.text.file + '?ts=' + Date.now();
    		},
            reset() {
                this.$refs.listeningTag.currentTime = 0;
            }
    	},
    	props: ['text']
	};
</script>